import Box from '@mui/material/Box'
import Image from 'next/image'

import { BlogPreview } from '@/components/blogSlices/BlogPreview'
import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const CuratePortfolios = () => {
    return (
        <Box>
            <TwoColumnLayout
                columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
                leftCol={6}
                rightCol={5}
            >
                <TitleAndParagraph
                    title={'Curate company-aligned portfolios'}
                    paragraph={
                        'Secure stakeholder confidence with climate projects that align seamlessly with your company values. Nobody knows your business better than you. Whether your focus is innovation or tradition, or Europe to Australia, our portfolio curator builds portfolios that resonate authentically with your business based on your requirements.'
                    }
                    snippet={
                        <BlogPreview
                            title={
                                'The Oxford Offsetting Principles: how to to maximise carbon offsetting impact'
                            }
                            url={
                                '/blog/the-oxford-offsetting-principles-a-framework-to-maximise-the-impact-of-business-carbon-offsetting'
                            }
                        />
                    }
                />
                <Box sx={{ img: { maxWidth: '100%', height: 'auto' } }}>
                    <Image
                        src={'/images/curate-portfolios.png'}
                        alt={'Curate company-aligned portfolios logos'}
                        width={486}
                        height={232}
                    />
                </Box>
            </TwoColumnLayout>
        </Box>
    )
}

export default CuratePortfolios
